import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, FIREARM_STORAGE_LOCATION_METADATA, FIREARM_STORAGE_LOCATION_PLI_TYPE, FIREARM_STORAGE_LOCATION_TYPE, FirearmStorageLocation, FirearmStorageLocationPLI, setDefaultLocationFromUser } from 'assets-model';
import { FirearmStorageLocationPLIService, FirearmStorageLocationService } from 'assets-service';


@Directive()
export abstract class FirearmStorageLocationPLIItemComponentBase extends CrudItemComponent<FirearmStorageLocationPLI, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  firearmStorageLocationSelectionList: FirearmStorageLocation[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected firearmStorageLocationPLIService: FirearmStorageLocationPLIService,
    protected firearmStorageLocationService: FirearmStorageLocationService,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(FIREARM_STORAGE_LOCATION_PLI_TYPE, fb, elementRef, router, route, userStorage, dialog, firearmStorageLocationPLIService, injector, snackbar);
  }

  createNewItem() {
    return new FirearmStorageLocationPLI();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      firearmStorageLocationPLIId: [null, []],
      firearmStorageLocation: [null, [requiredValidator,]],
      comments: [null, []],
      createdBy: [null, []],
      createdDate: [null, []],
      documentUploadedBy: [null, []],
      hasDocuments: [null, []],
      lockVersion: [null, []],
      updatedBy: [null, []],
      updatedDate: [null, []],
      validFromDate: [null, []],
      validToDate: [null, []]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.firearmStorageLocationPLIId?.disable();
    }
    this.documentUploadedBy?.disable();
    this.hasDocuments?.disable();
  }
  
  firearmStorageLocationPLIIdChanging(value: number, unsetDependents: boolean = true) {}
  
  firearmStorageLocationPLIIdChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.firearmStorageLocationPLIIdChangedByUser(value, unsetDependents);
    }
  }  
  
  firearmStorageLocationPLIIdChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  firearmStorageLocationDisplay(item: FirearmStorageLocation) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return FIREARM_STORAGE_LOCATION_TYPE.description(item);
  }
  
  firearmStorageLocationLoadSelectionList() {
    this.firearmStorageLocationService.findAll().subscribe(
      data => {
        this.firearmStorageLocationSelectionList = FIREARM_STORAGE_LOCATION_TYPE.entityDecorator.ensureContained(this.item && this.item.firearmStorageLocation, data.items);
      }
    );
  }

  firearmStorageLocationChanging(value: FirearmStorageLocation, unsetDependents: boolean = true) {}
  
  firearmStorageLocationChanged(value: FirearmStorageLocation, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.firearmStorageLocationChangedByUser(value, unsetDependents);
    }
  }  
  
  firearmStorageLocationChangedByUser(value: FirearmStorageLocation, unsetDependents: boolean = true) {
  }
  
  firearmStorageLocationCompare(a: any, b: any) {
    return FIREARM_STORAGE_LOCATION_METADATA.equals(a, b);
  }
  
  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.commentsChangedByUser(value, unsetDependents);
    }
  }  
  
  commentsChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.createdByChangedByUser(value, unsetDependents);
    }
  }  
  
  createdByChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.createdDateChangedByUser(value, unsetDependents);
    }
  }  
  
  createdDateChangedByUser(value: Date, unsetDependents: boolean = true) {
  }
  
  
  
  lockVersionChanging(value: number, unsetDependents: boolean = true) {}
  
  lockVersionChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.lockVersionChangedByUser(value, unsetDependents);
    }
  }  
  
  lockVersionChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.updatedByChangedByUser(value, unsetDependents);
    }
  }  
  
  updatedByChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.updatedDateChangedByUser(value, unsetDependents);
    }
  }  
  
  updatedDateChangedByUser(value: Date, unsetDependents: boolean = true) {
  }
  
  validFromDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  validFromDateChanged(value: Date, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.validFromDateChangedByUser(value, unsetDependents);
    }
  }  
  
  validFromDateChangedByUser(value: Date, unsetDependents: boolean = true) {
  }
  
  validToDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  validToDateChanged(value: Date, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.validToDateChangedByUser(value, unsetDependents);
    }
  }  
  
  validToDateChangedByUser(value: Date, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get firearmStorageLocationPLIId() {
    return this.control('firearmStorageLocationPLIId');
  }
  
  get firearmStorageLocation() {
    return this.control('firearmStorageLocation');
  }
  
  get comments() {
    return this.control('comments');
  }
  
  get createdBy() {
    return this.control('createdBy');
  }
  
  get createdDate() {
    return this.control('createdDate');
  }
  
  get documentUploadedBy() {
    return this.control('documentUploadedBy');
  }
  
  get hasDocuments() {
    return this.control('hasDocuments');
  }
  
  get lockVersion() {
    return this.control('lockVersion');
  }
  
  get updatedBy() {
    return this.control('updatedBy');
  }
  
  get updatedDate() {
    return this.control('updatedDate');
  }
  
  get validFromDate() {
    return this.control('validFromDate');
  }
  
  get validToDate() {
    return this.control('validToDate');
  }
  
}





